import api from '../utils/api';
import setAlert from './setAlert';

import * as actionTypes from './types';
import {loadUser} from "./auth";

// Get current users profile
export const getCurrentProfile = () => async (dispatch) => {
    try {
        const res = await api.get('/profile/me');

        dispatch({
            type: actionTypes.GET_PROFILE,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Get all profiles
export const getProfiles = () => async (dispatch) => {
    dispatch({type: actionTypes.CLEAR_PROFILE});

    try {
        const res = await api.get('/profile');

        dispatch({
            type: actionTypes.GET_PROFILES,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Get profile by ID
export const getProfileById = (userId) => async (dispatch) => {
    try {
        const res = await api.get(`/profile/user/${userId}`);

        dispatch({
            type: actionTypes.GET_PROFILE,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Get Github repos
export const getGithubRepos = (username) => async (dispatch) => {
    try {
        const res = await api.get(`/profile/github/${username}`);

        dispatch({
            type: actionTypes.GET_REPOS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: actionTypes.NO_REPOS
        });
    }
};

// Create or update profile
export const createProfile = (formData, history, edit = false) => async (
    dispatch
) => {
    try {
        const res = await api.post('/profile', formData);

        dispatch({
            type: actionTypes.GET_PROFILE,
            payload: res.data
        });

        dispatch(setAlert(edit ? 'Profile Updated' : 'Profile Created', 'success'));

        if (!edit) {
            history.push('/dashboard');
        }
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Add Experience
export const addExperience = (formData, history) => async (dispatch) => {
    try {
        const res = await api.put('/profile/experience', formData);

        dispatch({
            type: actionTypes.UPDATE_PROFILE,
            payload: res.data
        });

        dispatch(setAlert('Experience Added', 'success'));

        history.push('/dashboard');
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Add Education
export const addEducation = (formData, history) => async (dispatch) => {
    try {
        const res = await api.put('/profile/education', formData);

        dispatch({
            type: actionTypes.UPDATE_PROFILE,
            payload: res.data
        });

        dispatch(setAlert('Education Added', 'success'));

        history.push('/dashboard');
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Delete experience
export const deleteExperience = (id) => async (dispatch) => {
    try {
        const res = await api.delete(`/profile/experience/${id}`);

        dispatch({
            type: actionTypes.UPDATE_PROFILE,
            payload: res.data
        });

        dispatch(setAlert('Experience Removed', 'success'));
    } catch (err) {
        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Delete education
export const deleteEducation = (id) => async (dispatch) => {
    try {
        const res = await api.delete(`/profile/education/${id}`);

        dispatch({
            type: actionTypes.UPDATE_PROFILE,
            payload: res.data
        });

        dispatch(setAlert('Education Removed', 'success'));
    } catch (err) {
        dispatch({
            type: actionTypes.PROFILE_ERROR,
            payload: {msg: err.response.statusText, status: err.response.status}
        });
    }
};

// Delete account & profile
export const deleteAccount = () => async (dispatch) => {
    if (window.confirm('Are you sure? This can NOT be undone!')) {
        try {
            await api.delete('/profile');

            dispatch({type: actionTypes.CLEAR_PROFILE});
            dispatch({type: actionTypes.ACCOUNT_DELETED});

            dispatch(setAlert('Your account has been permanently deleted'));
        } catch (err) {
            dispatch({
                type: actionTypes.PROFILE_ERROR,
                payload: {msg: err.response.statusText, status: err.response.status}
            });
        }
    }
};

export const sendConnectionRequest = (senderID, receiverId) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.SEND_CONNECTION_REQUEST_LOADER,
            payload: true
        });
        const res = await api.put(`/connections/sendConnectionRequest/${senderID}/${receiverId}`);
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.SEND_CONNECTION_REQUEST_DATA,
                payload: res.data.data
            });

            dispatch({
                type: actionTypes.SEND_CONNECTION_REQUEST_LOADER,
                payload: false
            });
        }
        else {
            dispatch({
                type: actionTypes.SEND_CONNECTION_REQUEST_LOADER,
                payload: false
            });
        }

        // dispatch(loadUser());
        setAlert(res.data.message, 'success');
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error');
            dispatch({
                type: actionTypes.SEND_CONNECTION_REQUEST_LOADER,
                payload: false
            });
        }
    }
};


export const rejectConnectionRequest = (senderID, receiverId, id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.REJECT_CONNECTION_REQUEST_LOADER,
            payload: true
        });
        const res = await api.put(`/connections/rejectConnectionRequest/${senderID}/${receiverId}`);
        dispatch({
            type: actionTypes.REJECT_CONNECTION_UPDATE_NOTIFICATION_DATA,
            payload: id
        });
        dispatch({
            type: actionTypes.REJECT_CONNECTION_REQUEST_DATA,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.REJECT_CONNECTION_REQUEST_LOADER,
            payload: false
        });
        // dispatch(loadUser());
        setAlert(res.data.message, 'success');
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
    }
};

export const acceptConnectionRequest = (senderID, receiverId, id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.ACCEPT_CONNECTION_REQUEST_LOADER,
            payload: true
        });
        const res = await api.put(`/connections/AcceptConnectionRequest/${senderID}/${receiverId}`);
        dispatch({
            type: actionTypes.ACCEPT_CONNECTION_REQUEST_DATA,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.REJECT_CONNECTION_UPDATE_NOTIFICATION_DATA,
            payload: id
        });
        dispatch({
            type: actionTypes.ACCEPT_CONNECTION_REQUEST_LOADER,
            payload: false
        });
        // dispatch(loadUser());
        setAlert(res.data.message, 'success');
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
    }
};

export const removeConnectionRequest = (senderID, receiverId) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.REMOVE_FRIEND_CONNECTION_REQUEST_LOADER,
            payload: true
        });
        const res = await api.put(`/connections/removeConnection/${senderID}/${receiverId}`);
        dispatch({
            type: actionTypes.REMOVE_FRIEND_CONNECTION_REQUEST_DATA,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.REMOVE_FRIEND_CONNECTION_REQUEST_LOADER,
            payload: false
        });
        // dispatch(loadUser());
        setAlert(res.data.message, 'success');
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
    }
};
export const actionGetAgents = (request, setLastData) => async (dispatch, getState) => {
    dispatch({type: actionTypes.AGENT_LISTING_LOADER, payload: true});
    (request.q && parseInt(request.offset) === 0) && dispatch({
        type: actionTypes.REMOVE_AGENTS,
        payload: []
    });
    (!request.q.length > 0 && parseInt(request.offset) === 0) && dispatch({
        type: actionTypes.REMOVE_AGENTS,
        payload: []
    });
    try {
        let result = await api.post(`/users/getUsers`, JSON.stringify(request));
        dispatch({type: actionTypes.AGENT_LISTING_LOADER, payload: false});
        if (parseInt(result.data.status) === 200) {
            (request.q && parseInt(request.offset) === 0) && dispatch({
                type: actionTypes.REMOVE_AGENTS,
                payload: []
            });
            (!request.q.length > 0 && parseInt(request.offset) === 0) && dispatch({
                type: actionTypes.REMOVE_AGENTS,
                payload: []
            });
            if (result.data.data && result.data.data.length > 0) {
                setLastData && setLastData(true);
                dispatch({type: actionTypes.GET_AGENTS, payload: result.data.data});
            }
            else {
                setLastData && setLastData(false);
            }

        }
        else {
            dispatch({
                type: actionTypes.REMOVE_AGENTS,
                payload: []
            })
        }
    } catch (error) {
        setAlert(error.message, 'error');
    }
};
export const actionGetAgentsByRoll = (request) => async (dispatch, getState) => {
    dispatch({type: actionTypes.AGENT_LISTING_LOADER, payload: true});
    try {
        let result = await api.post(`/users/getUsers`, JSON.stringify(request));
        dispatch({type: actionTypes.AGENT_LISTING_LOADER, payload: false});
        if (parseInt(result.data.status) === 200) {
            dispatch({type: actionTypes.GET_AGENTS_BY_ROLE, payload: result.data.data});
        }
        else {
            dispatch({type: actionTypes.AGENT_LISTING_LOADER, payload: false});
        }
    } catch (error) {
        dispatch({type: actionTypes.AGENT_LISTING_LOADER, payload: false});
        setAlert(error.message, 'error');
    }
};
export const agentListing = (request) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.AGENT_LISTING_LOADER,
            payload: true
        });
        const res = await api.post('/users/getUsers', JSON.stringify(request));
        dispatch({
            type: actionTypes.AGENT_LISTING,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.AGENT_LISTING_LOADER,
            payload: false
        });

        // dispatch(setAlert(res.data.message),'success')
    } catch (error) {
        setAlert(error.message, 'error');

    }

};

export const getGroupConversation = (loggedInUserId, receiverID, groupId, limit, offset, scrollToBottom, decreasePageCount,isFirst) => async dispatch => {

    (offset === 0) && dispatch({
        type: actionTypes.GROUP_CONVERSATION_LISTING,
        payload: []
    });

    try {
        dispatch({
            type: actionTypes.GROUP_CONVERSATION_LISTING_LOADER,
            payload: true
        });
        const res = await api.get(`/groupConversation/${loggedInUserId}/${receiverID}/${groupId}/${limit}/${offset}`);
        if(parseInt(res.data.status) === 200){
            if(res.data.data&&res.data.data.newConversation&& res.data.data.newConversation.length>0){
                dispatch({
                    type: actionTypes.NEXT_GROUP_CONVERSATION_API_CALL,
                    payload: true
                });
            }
            else {
                dispatch({
                    type: actionTypes.NEXT_GROUP_CONVERSATION_API_CALL,
                    payload: false
                });
            }
            if(isFirst) {
                dispatch({
                    type: actionTypes.FIRTS_TIME_GROUP_CONVERSATION_LISTING,
                    payload: {receiverID: receiverID ? receiverID : groupId, conversation: res.data.data.newConversation}
                });

            }else {
                dispatch({
                    type: actionTypes.GROUP_CONVERSATION_LISTING,
                    payload: {receiverID: receiverID ? receiverID : groupId, conversation: res.data.data.newConversation}
                });
            }

            dispatch({
                type: actionTypes.SET_TOTAL_CONVERSATION_COUNT,
                payload: res.data.data.count
            });

            dispatch({
                type: actionTypes.GROUP_CONVERSATION_LISTING_LOADER,
                payload: false
            });

            decreasePageCount && decreasePageCount();
            setTimeout(() => scrollToBottom && scrollToBottom(), 1000);
        }else {
            dispatch({
                type: actionTypes.GROUP_CONVERSATION_LISTING_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GROUP_CONVERSATION_LISTING,
                payload: []
            });
        }
    } catch (error) {
        setAlert(error.message, 'error');
        dispatch({
            type: actionTypes.GROUP_CONVERSATION_LISTING_LOADER,
            payload: false
        });
    }
};

// export const appendChatMessage = (messageData, ID) => async dispatch => {
export const appendChatMessage = (messageData) => async dispatch => {
    // console.log(messageData,'messageData');

    dispatch({
        type: actionTypes.APPEND_CHAT_MESSAGE,
        // payload: {messageData, id: ID}
        payload: messageData

    });
    console.log(messageData)
};

// export const appendChatMessage = (messageData, ID) => async dispatch => {
export const appendReceiveChatMessage = (messageData) => async dispatch => {
    console.log(messageData,'Receiver messageData');

    dispatch({
        type: actionTypes.APPEND_RECEIVER_CHAT_MESSAGE,
        // payload: {messageData, id: ID}
        payload: messageData

    });
    console.log(messageData)
};

export const appendLastChatMessage = (messageData) => async dispatch => {
    // console.log(messageData,'messageData');

    dispatch({
        type: actionTypes.APPEND_LAST_CHAT_MESSAGE,
        // payload: {messageData, id: ID}
        payload: messageData

    });
    console.log(messageData)
};

export const setDataInRedux = (messageData) => async dispatch => dispatch({
    type: actionTypes.SET_CHAT_DATA_REDUX,
    payload: messageData
});

export const setOnlineInRedux = (payload) => async dispatch => dispatch({
    type: actionTypes.SET_ONLINE_DATA_REDUX,
    payload
});

export const removeDataInRedux = () => async dispatch => dispatch({
    type: actionTypes.SET_CHAT_DATA_REDUX,
    payload: ''
});

export const changeGroupName = (groupData) => async dispatch => dispatch({
    type: actionTypes.GROUP_MESSAGE,
    payload: groupData
});


export const createGroup = (request) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.CREATE_GROUP_LOADER,
            payload: true
        });
        const res = await api.post('/group', JSON.stringify(request));
        dispatch({
            type: actionTypes.CREATE_GROUP_LISTING,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.CREATE_GROUP_LOADER,
            payload: false
        });

        setAlert(res.data.message, 'success')
    } catch (error) {
        const errors = error.response.data.errors;
        if (errors) {
            errors.forEach(error => setAlert(error.msg, 'error'))
        }
    }
};

export const UpdateGroup = (Id, request) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.UPDATE_GROUP_LOADER,
            payload: true
        });
        const res = await api.put(`/group/${Id}`, JSON.stringify(request));
        dispatch({
            type: actionTypes.UPDATE_GROUP_LISTING,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.UPDATE_GROUP_LOADER,
            payload: false
        });

        setAlert(res.data.message, 'success')
    } catch (error) {
        setAlert(error.message, 'error');

    }

};

export const UpdateGroupBackend = (Id, request) => async dispatch => {
    try {
        const res = await api.put(`/group/${Id}`, JSON.stringify(request));
        dispatch({
            type: actionTypes.UPDATE_GROUP_LISTING_BACKEND,
            payload: res.data.data
        });
        setAlert(res.data.message, 'success')
    } catch (error) {
        setAlert(error.message, 'error');

    }

};

export const DeleteGroup = (Id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.DELETE_GROUP_LOADER,
            payload: true
        });
        const res = await api.delete(`/group/${Id}`);
        dispatch({
            type: actionTypes.DELETE_GROUP_LISTING,
            payload: Id
        });
        dispatch({
            type: actionTypes.DELETE_GROUP_LOADER,
            payload: false
        });

        setAlert(res.data.message, 'success')
    } catch (error) {
        setAlert(error.message, 'error');

    }

};


export const getConnection = (Id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.CONNECTION_LISTING_LOADER,
            payload: true
        });
        const res = await api.get(`/connections/${Id}`);
        dispatch({
            type: actionTypes.CONNECTION_LISTING,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.CONNECTION_LISTING_LOADER,
            payload: false
        });

    } catch (error) {
        setAlert(error.message, 'error');

    }
};

export const getChatList = (Id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.GROUP_LISTING_LOADER,
            payload: true
        });
        const res = await api.get(`/chat/get-chat-list/${Id}`);
        dispatch({
            type: actionTypes.GROUP_LISTING,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.GROUP_LISTING_LOADER,
            payload: false
        });

    } catch (error) {
        setAlert(error.message, 'error');

    }
};

export const exitFromGroup = (GroupId,MemberId) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.EXIT_GROUP_LISTING_LOADER,
            payload: true
        });
        const res = await api.put(`/group/exit-group/${GroupId}/${MemberId}`);
        dispatch({
            type: actionTypes.EXIT_GROUP_LISTING,
            payload: GroupId
        });
        dispatch({
            type: actionTypes.EXIT_GROUP_LISTING_LOADER,
            payload: false
        });
        setAlert(res.data.message, 'success')
    } catch (error) {
        setAlert(error.message, 'error');

    }
};
// export const actionGetRole = () => async dispatch => {
//     try {
//         dispatch({
//             type: actionTypes.GET_ROLE_LOADER,
//             payload: true
//         });
//         const res = await api.get(`/role`);
//         dispatch({
//             type: actionTypes.GET_ROLE,
//             payload: res.data
//         });
//         dispatch({
//             type: actionTypes.GET_ROLE_LOADER,
//             payload: false
//         });
//
//     } catch (error) {
//         setAlert(error.message, 'error');
//
//     }
// };

export const actionGetUserById = (id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.GET_SINGLE_USER_LOADER,
            payload: true
        });
        const res = await api.get(`/users/${id}`);
        dispatch({
            type: actionTypes.GET_SINGLE_USER,
            payload: res.data
        });
        dispatch({
            type: actionTypes.GET_SINGLE_USER_LOADER,
            payload: false
        });

    } catch (error) {
        setAlert(error.message, 'error');

    }
};

export const actionUpdateUserById = (id, request, history) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.UPDATE_SINGLE_USER_LOADER,
            payload: true
        });
        const res = await api.put(`/users/${id}`, JSON.stringify(request));
        dispatch({
            type: actionTypes.UPDATE_SINGLE_USER_LOADER,
            payload: false
        });
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.UPDATE_SINGLE_USER,
                payload: res.data.data
            });

            setAlert(res.data.message, 'success');
            history && history.push('/users')
        }

    } catch (error) {
        setAlert(error.message, 'error');

    }
};

export const actionDeleteUserById = (id, history) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.DELETE_SINGLE_USER_LOADER,
            payload: true
        });
        const res = await api.delete(`/users/${id}`);
        dispatch({
            type: actionTypes.DELETE_SINGLE_USER_LOADER,
            payload: false
        });
        dispatch({
            type: actionTypes.DELETE_SINGLE_USER,
            payload: id
        });
        setAlert(res.data.msg, 'success');
        history && history.push('/users')
    } catch (error) {
        setAlert(error.message, 'error');

    }
};

// GET ALL PERMISSION
export const actionGetPermissions = (id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.GET_PERMISSION_LOADER,
            payload: true
        });
        const res = await api.get(`/permission`);

        if(parseInt(res.data.status) === 200){
            dispatch({
                type: actionTypes.GET_PERMISSIONS,
                payload: res.data.data
            });
            dispatch({
                type: actionTypes.GET_PERMISSION_LOADER,
                payload: false
            });
        }
        else {
            setAlert(res.data.msg, 'error');
            dispatch({
                type: actionTypes.GET_PERMISSION_LOADER,
                payload: false
            });
        }


    } catch (error) {
        setAlert(error.message, 'error');
        dispatch({
            type: actionTypes.GET_PERMISSION_LOADER,
            payload: false
        });
    }
};

// GET ALL ROLES
export const actionGetRole = (id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.GET_ROLE_LOADER,
            payload: true
        });
        const res = await api.get(`/role`);
        if(parseInt(res.data.status) === 200){
            dispatch({
                type: actionTypes.GET_ROLE,
                payload: res.data.data
            });
            dispatch({
                type: actionTypes.GET_ROLE_LOADER,
                payload: false
            });
        }
        else {
            setAlert(res.data.msg, 'error');
            dispatch({
                type: actionTypes.GET_ROLE_LOADER,
                payload: false
            });
        }


    } catch (error) {
        setAlert(error.message, 'error');
        dispatch({
            type: actionTypes.GET_ROLE_LOADER,
            payload: false
        });
    }
};

// GET SINGLE ROLE DETAILS
export const actionGetSingleRoleDetails = (id) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.GET_ROLE_LOADER,
            payload: true
        });
        const res = await api.get(`/role/${id}`);
        if(parseInt(res.data.status) === 200){
            dispatch({
                type: actionTypes.GET_SINGLE_ROLE_DETAILS,
                payload: res.data.data
            });
            dispatch({
                type: actionTypes.GET_ROLE_LOADER,
                payload: false
            });
        }
        else {
            setAlert(res.data.msg, 'error');
            dispatch({
                type: actionTypes.GET_ROLE_LOADER,
                payload: false
            });
        }


    } catch (error) {
        setAlert(error.message, 'error');
        dispatch({
            type: actionTypes.GET_ROLE_LOADER,
            payload: false
        });
    }
};

// ADD UPDATE ROLE WISE PERMISSION
export const actionAddUpdateRole = (id,request,closeModal) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.GET_ROLE_LOADER,
            payload: true
        });
        const res = await api.put(`/role/${id}`,JSON.stringify(request));
        if(parseInt(res.data.status) === 200){
            dispatch({
                type: actionTypes.ADD_UPDATE_ROLE,
                payload: res.data.data
            });
            dispatch({
                type: actionTypes.GET_ROLE_LOADER,
                payload: false
            });
            // closeModal&&closeModal();
        }
        else {
            setAlert(res.data.msg, 'error');
            dispatch({
                type: actionTypes.GET_ROLE_LOADER,
                payload: false
            });
        }


    } catch (error) {
        setAlert(error.message, 'error');
        dispatch({
            type: actionTypes.GET_ROLE_LOADER,
            payload: false
        });
    }
};
